module.exports = __webpack_public_path__ + "img/resolve_introduction.628f6a79.svg";